import * as Yup from "yup";

export const PAGE_TYPE = {
  CREATE: "create",
  EDIT: "edit",
};

export const DEFAULT_SHIFTPERIOD = {
  activateDeactivate: true,
  workingDayId: null,
  optionId: null,
  workTimeStart: "08:30:00",
  workTimeEnd: "17:30:00",
  breakTimeStart: "12:00:00",
  breakTimeEnd: "13:00:00",
  otTimeStart: "17:30:00",
  otTimeEnd: "08:30:00",
};

export const initialValues = {
  colorCode: "#fff",
  shiftName: null,
  shiftNameEn: null,
  shiftCode: null,
  description: null,
  doubleShift: false,
  nightShift: false,
  advanceSetting: true,
  shiftPeriods: [DEFAULT_SHIFTPERIOD],
  normalShifts: [],
  advanceShifts: [],
  attendanceConditionId: null,
  preShiftOtPeriod: false,
  requestOtAfter: "00:00:00",
  calculateOtAuto: false,
  checkInChanelId: null,
  beforeOtAutoCalculate: null,
  afterOtAutoCalculate: null,
  openAllowanceTab: false,
  allowancePay: null,
  specialShiftFromOt: false,
  completeWorkInFromOt: null,
  willBePaidFromOt: null,
  specialShiftFromHoliday: false,
  allowancePayFromHoliday: null,
  workTimeAllowance: false,
  completeWorkInWorkTime: null,
  willBePaidWorkTime: null,
  lateStatusDuringBreaksCalculation: false,
  allowedToStampOutBefore: null,
  mustStampOutAfter: null,
  allowedToStampInBefore: null,
  mustStampInAfter: null,
};

const ShiftsSchema = Yup.object().shape({
  shiftName: Yup.string().required("Please enter."),
  shiftCode: Yup.string().required("Please enter."),
  description: Yup.string().required("Please enter."),
  attendanceConditionId: Yup.string().when("doubleShift", {
    is: (val) => val === false,
    then: () => Yup.string().required("Please select."),
    otherwise: () => Yup.string().notRequired(),
  }),
});

export default ShiftsSchema;
